import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import Text from "../Text/Text";
import styles from "./Form.module.scss";
import Icon from "../../assets/icons/Icon";

/** For submitting details to receive a full DMA report */
const Form = React.forwardRef((props, ref) => {
  const { handleModal } = props;
  const [formSubmitted] = useState(false);
  const [formError] = useState(false);

  function loadScript(src) {
    const tag = document.createElement("script");
    tag.async = false;
    tag.src = src;
    document.getElementsByTagName("body")[0].appendChild(tag);
    tag.onload = () => {
      window.MktoForms2.loadForm(
        "//app-lon08.marketo.com",
        "445-UIT-144",
        2850
      );
    };
  }
  useEffect(() => {
    loadScript("//app-lon08.marketo.com/js/forms2/js/forms2.min.js");
  }, []);

  return (
    <div className={styles.form_wrapper}>
      <form ref={ref} className={styles.form}>
        <div className={styles.form_body}>
          {formSubmitted ? (
            <FormSuccess />
          ) : (
            <>
              <Text
                variant="subheading"
                weight="bold"
                className={styles.form_title}
              >
                <div className={styles.form_title_icon_container}>
                  <Icon className={styles.form_title_icon} icon="GtCheckmark" />
                </div>
                Get in touch to schedule your full Digital Maturity Assessment
                today
              </Text>
              <form id="mktoForm_2850" />
            </>
          )}

          {formError ? (
            <Text variant="bodyRegular" className={styles.form_error}>
              Something went wrong. Please try again. If the problem persists,
              please reach out directly to{" "}
              <a href="mailto:hesus.inoma@ie.gt.com">Hesus Inoma</a>.
            </Text>
          ) : null}
        </div>
        <div className={styles.form_footer}>
          {formSubmitted ? (
            <Button onClick={() => handleModal(false)} size="md">
              Close
            </Button>
          ) : (
            <ButtonGroup
              isDisabled={formSubmitted}
              variant={["ghost", "filled"]}
              size="md"
              justify="end"
              className={styles.footer_group}
            />
          )}
        </div>
      </form>
    </div>
  );
});

function FormSuccess() {
  return (
    <div className={styles.form_success}>
      <Text className={styles.form_success_message}>
        Thank you. We will be in touch shortly.
      </Text>
    </div>
  );
}

export default Form;
